import { cn } from '../../../utils/string/cn.utils';

export const CardDetailProduct = ({
  title,
  content,
  icon,
  actions,
  classNames = { root: '', icon: '', actionsContainer: '' },
}) => {
  return (
    <div
      className={cn(
        'flex items-center self-stretch rounded-[16px] bg-fills-white shadow-custom',
        classNames.root
      )}
    >
      <div className="flex lg:p-[40px] p-16 items-start gap-[8px] self-stretch">
        <div
          style={{ backgroundImage: `url(${icon})` }}
          alt={title}
          className={cn(
            'lg:w-[120px] lg:h-[120px] w-[88px] h-[88px] rounded-[2px] bg-[lightgray] bg-center bg-cover bg-no-repeat aspect-square',
            classNames.icon
          )}
        ></div>
      </div>
      <div className="flex lg:p-[40px] p-16 ps-0 flex-col items-start gap-[12px] grow self-stretch">
        <div className="flex content-center items-center gap-[8px] self-stretch">
          <span className="text-title-medium line-clamp-1 grow truncate">
            {title}
          </span>
          <div
            className={cn(
              'flex content-center items-center self-stretch gap-[8px]',
              classNames.actionsContainer
            )}
          >
            {actions}
          </div>
        </div>
        <div className="flex flex-col items-start gap-[12px] self-stretch grow">
          {content}
        </div>
      </div>
    </div>
  );
};
